/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FamilyPoolRelationship } from './FamilyPoolRelationship';
import {
    FamilyPoolRelationshipFromJSON,
    FamilyPoolRelationshipFromJSONTyped,
    FamilyPoolRelationshipToJSON,
    FamilyPoolRelationshipToJSONTyped,
} from './FamilyPoolRelationship';

/**
 * 
 * @export
 * @interface FamilyPoolRelationshipListResponse
 */
export interface FamilyPoolRelationshipListResponse {
    /**
     * 
     * @type {Array<FamilyPoolRelationship>}
     * @memberof FamilyPoolRelationshipListResponse
     */
    items?: Array<FamilyPoolRelationship>;
}

/**
 * Check if a given object implements the FamilyPoolRelationshipListResponse interface.
 */
export function instanceOfFamilyPoolRelationshipListResponse(value: object): value is FamilyPoolRelationshipListResponse {
    return true;
}

export function FamilyPoolRelationshipListResponseFromJSON(json: any): FamilyPoolRelationshipListResponse {
    return FamilyPoolRelationshipListResponseFromJSONTyped(json, false);
}

export function FamilyPoolRelationshipListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolRelationshipListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(FamilyPoolRelationshipFromJSON)),
    };
}

export function FamilyPoolRelationshipListResponseToJSON(json: any): FamilyPoolRelationshipListResponse {
    return FamilyPoolRelationshipListResponseToJSONTyped(json, false);
}

export function FamilyPoolRelationshipListResponseToJSONTyped(value?: FamilyPoolRelationshipListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(FamilyPoolRelationshipToJSON)),
    };
}

